<template>
  <div id="app">
    <Gacha msg="ローソンがちゃ"/>
  </div>
</template>

<script>
import Gacha from './components/Gacha.vue';

export default {
  name: 'app',
  components: {
    Gacha,
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
html {
  height:100%;
  background: #F6F8FA;
  color: #0368A5
}
</style>
